import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion } from '@mantine/core';
import React from 'react';
import './FAQ.css';

const FAQ = ({ faqRef }) => {
    const customerQueries = [
        {
            value: 'How do I know when my order has been confirmed? Do I need to create an account to place my order?',
            description: 'Since it’s a business-only website, we do not encourage retail sales. You will need to create an account by submitting business credentials to place bulk orders. You will receive an email notifying you when your registration is confirmed.',
        },
        {
            value: 'Do you deliver outside India? How safe is it to use net banking, debit, or credit card for payment on your website?',
            description: 'No, currently we do not deliver outside India.',
        },
        {
            value: 'Does FabInsta have an email ID for contact? I cannot complete my registration, what can I do?',
            description: (
                <>
                    Yes, we have a call center as well as a support email service to provide you with the best experience.
                    You can email your queries to{" "}
                    <a href="mailto:support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}>
                        support@fabinsta.com
                    </a>{" "}
                    or call us at{" "}
                        +91 7010122747
                    {" "}
                    for immediate assistance. Once you register, you will be assigned an account manager to guide you with your orders.
                </>
            ),
        },
        {
            value: 'Can my products be shipped to an address different from the billing address? Can I choose my delivery date?',
            description: (
                <>
                    Yes, you can have your products shipped to an address different from the billing address.
                    Simply fill in your desired address under <b>"Shipping Address"</b> to have it delivered to the desired location.
                    Delivery dates cannot be selected or changed.
                </>
            ),
        },
        {
            value: 'Can my shipping address be modified?',
            description: (
                <>
                    You can request a change in the shipping address if the item has not been dispatched for delivery.
                    Please email us at{" "}
                    <a href="mailto:support@fabinsta.com" style={{ textDecoration: "underline", color: "#8BC53F" }}>
                        support@fabinsta.com
                    </a>{" "}
                    or call us at{" "}
                        +91 8072004304
                     and we shall be more than happy to assist you.
                </>
            ),
        },

        {
            value: 'Can my order be modified or canceled?',
            description: (
                <>
                    You can cancel or modify your order provided it has not been approved by the sales team and has not been sent for packing. Kindly follow the steps below:<br />
                    1. Go to https://fabinsta.com<br />
                    2. Click on "My Account"<br />
                    3. Under "My Account", select "My Orders" and click on "Modify" to edit or change your details<br />
                    4. Once done, click on "Save Changes" to save the details<br />
                    5. You can only modify orders in the "New" stage.
                </>
            ),
        },
        {
            value: 'I forgot my password, what can I do?',
            description: 'By clicking on the "Forgot Password" option, you can generate a request for a new password to be sent to your registered email. Follow the steps mentioned in the email to reset your password.',
        },
        {
            value: 'How can I track my order?',
            description: (
                <>
                    Kindly follow the steps below to track your order:<br />
                    1. Go to www.fabinsta.com<br />
                    2. Click on "My Account"<br />
                    3. Under "My Account", select "My Orders" and click on "Track My Order"<br />
                    4. You will then be asked for your Tracking Number, which was initially emailed to you upon order completion. Enter the same, and your details will be fetched.
                </>
            ),
        },
        {
            value: 'How do I request a refund for my canceled order?',
            description: 'Please refer to our Return and Exchange Policy to see if your order qualifies for a refund. If it qualifies, we will issue a credit note that you can redeem against your next purchase.',
        },
        {
            value: 'Get in touch',
            description: (
                <>
                    For any other assistance regarding refunds, please contact +91 7010122747 or email us at
                    <a href="mailto:support@fabinsta.com" style={{ color: '#8BC53F' }}> support@fabinsta.com</a>.
                </>
            ),
        },
    ];

    return (
        <div className="info-container" ref={faqRef}>
            <div className="info-content" data-aos="fade-down">
                <h3 className="info-title">Customer Queries</h3>
                <h2 className="info-heading">The Most Frequently Asked Questions by Customers</h2>
                <p className="info-description">
                    Have questions about our fabrics, services, or company? Find answers here. Our FAQ section provides clarity on our products, processes, and policies, helping you make informed decisions.
                </p>
            </div>
            <div className="info-extras">
                <Accordion variant="default" transitionDuration={1000} className="info-extra">
                    {customerQueries.map((item) => (
                        <Accordion.Item key={item.value} value={item.value} className="accordion-item">
                            <Accordion.Control className="questions" style={{ fontWeight: 'bold' }}>{item.value}</Accordion.Control>
                            <Accordion.Panel className="answer">{item.description}</Accordion.Panel>
                        </Accordion.Item>
                    ))}
                </Accordion>
                {/* <button className="faq-read-more">Explore More <FontAwesomeIcon className="btn_icon" icon={faCircleArrowRight} /></button> */}
            </div>
        </div>
    );
};

export default FAQ;